import React, { Fragment } from "react";
import EmailTemplatesListTable from "./EmailTemplatesListTable";
import { Box, Grid } from "@mui/material";
import { GridSpg, TableSkeleton } from "@duosoftbg/nacid-components";
import DeleteEmailTemplateDialog from "./dialog/DeleteEmailTemplateDialog";
import ViewEmailTemplateDialog from "./dialog/ViewEmailTemplateDialog";
import SaveEmailTemplateDialog from "./dialog/SaveEmailTemplateDialog";

const EmailTemplatesList = ({ records, total, isLoading, onPageOrOrderChange, blockTable, group, filterFn }) => {
  const showTable = () => {
    return (
      <Fragment>
        <DeleteEmailTemplateDialog filterFn={filterFn} records={records} total={total} />
        <SaveEmailTemplateDialog filterFn={filterFn} />
        <ViewEmailTemplateDialog />
        <EmailTemplatesListTable
          records={records}
          total={total}
          onPageOrOrderChange={onPageOrOrderChange}
          blockTable={blockTable}
          group={group}
        />
      </Fragment>
    );
  };

  return (
    <Box>
      <Grid container spacing={1}>
        <GridSpg item xs={12}>
          {isLoading ? <TableSkeleton /> : showTable()}
        </GridSpg>
      </Grid>
    </Box>
  );
};

export default EmailTemplatesList;
